import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import * as api from './api';

const obrasKey = ['obras'] as const;
const centrosKey = ['centros-custo'] as const;

export function useObras() {
  return useQuery({ queryKey: obrasKey, queryFn: api.listObras });
}

export function useCentrosCusto() {
  return useQuery({ queryKey: centrosKey, queryFn: api.listCentrosCusto });
}

export function useCreateObra() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (nome: string) => api.createObra(nome),
    onSuccess: () => qc.invalidateQueries({ queryKey: obrasKey }),
  });
}

export function useUpdateObra() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, nome }: { id: string; nome: string }) => api.updateObra(id, nome),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: obrasKey });
      qc.invalidateQueries({ queryKey: ['guias'] }); // guias may have moved obra
    },
  });
}

export function useDeleteObra() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.deleteObra(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: obrasKey }),
  });
}

export function useMergeObra() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ sourceId, targetId }: { sourceId: string; targetId: string }) =>
      api.mergeObra(sourceId, targetId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: obrasKey });
      qc.invalidateQueries({ queryKey: ['guias'] });
    },
  });
}

export function useCreateCentroCusto() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (nome: string) => api.createCentroCusto(nome),
    onSuccess: () => qc.invalidateQueries({ queryKey: centrosKey }),
  });
}

export function useUpdateCentroCusto() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, nome }: { id: string; nome: string }) => api.updateCentroCusto(id, nome),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: centrosKey });
      qc.invalidateQueries({ queryKey: ['guias'] });
    },
  });
}

export function useDeleteCentroCusto() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.deleteCentroCusto(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: centrosKey }),
  });
}
